import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BillingContext = createContext(null);

export function BillingProvider({ children }) {
  // null = loading, false = failed to load
  const [sub, setSub] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/subscription");
      setSub(data);
    } catch {
      setSub(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    // Keep the trial countdown current for long-lived tabs: re-check when the
    // tab regains focus/visibility (e.g. the user comes back the next day).
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", refresh);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", refresh);
    };
  }, [refresh]);

  // fail closed: an unknown subscription unlocks nothing
  const has = (feature) => Boolean(sub) && (sub.features || []).includes(feature);

  return (
    <BillingContext.Provider value={{ sub, refresh, has }}>{children}</BillingContext.Provider>
  );
}

export const useBilling = () => useContext(BillingContext);
